export type BaseRoute = "owner" | "manager" | "consultant" | "client"

export type Module =
  | BaseRoute
  | "publisher"
  | "support"
  | "demo"
  | "poc"
  | "admin"
  | "contentAutomation"
  | "cashManagement"
  | "Asset List"
  | "corporationList"
  | "fundList"
  | "addOns"
  | "spcList"
  | "test"
  | "batchJob"
  | "unstructuredDocument"

export type Role = "admin" | "user" | "readonly"

export enum DocumentTypeRef {
  PA_CASHFLOW = "PA_CASHFLOW",
  PA_DISTRIBUTION = "PA_DISTRIBUTION",
  PA_CONTRIBUTION = "PA_CONTRIBUTION",
  PA_FIN_STATEMENT = "PA_FIN_STATEMENT",
  PA_INVEST_REPORT = "PA_INVEST_REPORT",
  PA_CAPITAL_ACC = "PA_CAPITAL_ACC",
  CORP_CFD = "CORP_CFD",
  MMR_DOC = "MMR_DOC",
  MF_PROSPECTUS = "MF_PROSPECTUS"
}

export enum DataPointFormatTypeId {
  GPT = "1",
  MULTIPLIER = "2",
  REGEXP = "3"
}
export enum SignOperation {
  NONE = "None",
  REVERSE = "reverse_sign",
  ALWAYS_POSITIVE = "always_positive",
  ALWAYS_NEGATIVE = "always_negative"
}

export enum ValueSign {
  NONE = "",
  POSITIVE = "positive",
  NEGATIVE = "negative"
}

export enum LoadingMessage {
  UPLOADS_MESSAGE = "Loading Uploads...",
  LOADING_MESSAGE = "Loading..."
}

export enum OrganisationCategory {
  ASSET_OWNER = "Asset owner",
  ASSET_MANAGER = "Asset manager",
  CONSULTANT = "Consultant",
  OTHERS = "Others",
  ACCOUNTANT = "Accountant",
  VA = "VA"
}

export enum OrganisationTypeId {
  MANAGER = 1
}

export enum CharacterLimits {
  VAR_CHAR_512 = 512,
  VAR_CHAR_255 = 255,
  VAR_CHAR_8192 = 8192
}

export enum OrganisationPackage {
  SMDAM_MUTUAL_FUND_PROSPECTUS = "SMDAM Mutual Fund Prospectus"
}

export enum EstablishmentableTypeRef {
  CORPORATION = "CORPORATION",
  FUND = "FUND"
}

export enum EstablishmentableType {
  CORPORATION = "Corporation",
  FUND = "Fund"
}

export enum EstablishmentDocumentItemMappingType {
  Cashflow = "1"
}

export enum EstablishmentDocumentItemMappingOperation {
  Sum = "2"
}

export enum DataPointFormat {
  Currency3Decimal = "#,##0.000",
  Currency = "#,##0",
  Percentage = "0.000%"
}

export enum CommentableTypeRef {
  INSTRUCTION = "INSTRUCTION",
  CASHFLOW = "CASHFLOW"
}

export enum FundClassificationName {
  Benchmark = "Benchmark"
}

export enum FundRefSuffix {
  Benchmark = "-BM-"
}

export enum FundNoticeLevel {
  LP = "LP",
  FUND = "Fund"
}

export enum BankAccountAssociateCategories {
  organisation = "1",
  fund = "2"
}
